function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState } from 'react';
import { Card, Column, Popover } from 'seagull';
import { ColorPicker } from "../../../components/ColorPicker/ColorPicker";
import { ColorSelector } from "../../../components/ColorSelector/ColorSelector";
import styles from "./BrandingControllers.module.scss";
import { PRESET_SOLID_COLORS } from "./brandingPresetColors";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function ColorSelectorWithPopup(props) {
  const {
    branding,
    colorKey,
    hasError,
    onChange
  } = props;
  const color = branding[colorKey];
  const [anchorEl, setAnchorEl] = useState(null);
  function changeColor(newColor) {
    onChange(_objectSpread(_objectSpread({}, branding), {}, {
      [colorKey]: newColor
    }));
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ColorSelector, {
      withBorder: true,
      color: color,
      hasError: hasError,
      testid: "color-selector-".concat(colorKey),
      onClick: e => setAnchorEl(e.currentTarget)
    }), /*#__PURE__*/_jsx(Popover, {
      anchorEl: anchorEl,
      open: !!anchorEl,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      },
      transformOrigin: {
        vertical: -5,
        horizontal: 'right'
      },
      onClose: () => setAnchorEl(null),
      children: /*#__PURE__*/_jsx(Card, {
        className: styles.colorSelectorPopoverCard,
        children: /*#__PURE__*/_jsxs(Column, {
          gap: 16,
          alignItems: "stretch",
          className: styles.colorSelectorPopoverContent,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.colorsGrid,
            children: PRESET_SOLID_COLORS.map((presetColor, idx) => /*#__PURE__*/_jsx(ColorSelector, {
              withBorder: true,
              color: presetColor,
              selected: presetColor.toLowerCase() === (color || '').toLowerCase(),
              testid: "color-preset-".concat(idx),
              onClick: () => changeColor(presetColor)
            }, presetColor))
          }), /*#__PURE__*/_jsx(ColorPicker, {
            colorAsSuffix: true,
            noMinWidth: true,
            className: styles.colorPicker,
            testid: "color-picker-".concat(colorKey),
            color: color,
            displayColor: color,
            onChange: newColor => changeColor(newColor)
          })]
        })
      })
    })]
  });
}

/** Sets multiple branding keys to the same color (e.g. primary background = gradient start + end). */

export function ColorSelectorWithPopupMulti(props) {
  const {
    branding,
    colorKeys,
    hasError,
    onChange
  } = props;
  const color = branding[colorKeys[0]];
  const [anchorEl, setAnchorEl] = useState(null);
  function changeColor(newColor) {
    const next = _objectSpread({}, branding);
    colorKeys.forEach(key => {
      next[key] = newColor;
    });
    onChange(next);
  }
  const testid = "color-selector-".concat(colorKeys.join('-'));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ColorSelector, {
      withBorder: true,
      color: color,
      hasError: hasError,
      testid: testid,
      onClick: e => setAnchorEl(e.currentTarget)
    }), /*#__PURE__*/_jsx(Popover, {
      anchorEl: anchorEl,
      open: !!anchorEl,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      },
      transformOrigin: {
        vertical: -5,
        horizontal: 'right'
      },
      onClose: () => setAnchorEl(null),
      children: /*#__PURE__*/_jsx(Card, {
        className: styles.colorSelectorPopoverCard,
        children: /*#__PURE__*/_jsxs(Column, {
          gap: 16,
          alignItems: "stretch",
          className: styles.colorSelectorPopoverContent,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.colorsGrid,
            children: PRESET_SOLID_COLORS.map((presetColor, idx) => /*#__PURE__*/_jsx(ColorSelector, {
              withBorder: true,
              color: presetColor,
              selected: presetColor.toLowerCase() === (color || '').toLowerCase(),
              testid: "color-preset-".concat(idx),
              onClick: () => changeColor(presetColor)
            }, presetColor))
          }), /*#__PURE__*/_jsx(ColorPicker, {
            colorAsSuffix: true,
            noMinWidth: true,
            className: styles.colorPicker,
            testid: "color-picker-".concat(testid),
            color: color,
            displayColor: color,
            onChange: newColor => changeColor(newColor)
          })]
        })
      })
    })]
  });
}